import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { SectionHeading } from "components/misc/Headings";

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900 mb-10`;
const Text = styled.div`
  ${tw`text-lg  text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
  ul {
    ${tw`list-disc list-inside`}
    li {
      ${tw`ml-2 mb-3`}
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;
export default ({ headingText = "プライバシーポリシー" }) => {
    return (
        <AnimationRevealPage>
            <Header />
            <Container>
                <ContentWithPaddingXl>
                    <HeadingRow>
                        <Heading>{headingText}</Heading>
                    </HeadingRow>
                    <Text>
                        <p>有効日：2024年3月1日</p>

                        <p>
                            「Red Falcon のすべてのゲーム」へようこそ！Red Falcon Companyは、お客様の個人情報とプライバシーを保護することに努めています。このプライバシーポリシー契約では、Red Falcon のすべてのゲームを使用する際に私たちがどのように情報を収集、使用、保護するかを説明します。本サービスをご利用になる前に、この契約をよくお読みください。
                        </p>

                        <p>
                            私たちは、サービスの提供と改善のためにお客様の個人データを使用します。サービスを使用することで、本プライバシーポリシーに従って情報の収集と使用に同意するものとします。
                        </p>

                        <p>
                            私たちのゲームをプレイしてくださってありがとうございます！このプライバシーポリシーは、次のことを説明します：
                        </p>
                        <ul>
                            <li>
                                <p>
                                    あなたについての個人データをどのように、なぜ収集するか
                                </p>
                            </li>
                            <li>
                                <p>
                                    あなたの個人データをどのように使用するか、そして
                                </p>
                            </li>
                            <li>
                                あなたの個人データに関してあなたが持つ選択肢。
                            </li>
                        </ul>
                        <p>
                            このプライバシーポリシーは、Red Falconのゲーム、ストア、サイト、および関連サービスに適用されます。これらを総称して「サービス」と呼びます。私たちは定期的に新しいバージョンをfalcon-games.comに掲載することにより、このプライバシーポリシーを更新することがあります。重要な変更がある場合には、変更が有効になる前にサービス内で通知を行い、適用される法律の要件に従ってお知らせします。有効日以降のサービスのご利用は、新しいプライバシーポリシーの対象となります。
                        </p>
                       
                        <h2>私たちが収集するデータ</h2>
                        <p>
                            私たちが収集する個人データのカテゴリは、ご利用のサービスと適用される法律の要件によります。
                        </p>
                        <p>
                            直接提供されたデータ。
                        </p>
                        <p>
                            ▪連絡先情報（例：メールアドレス）
                        </p>
                        <p>
                            ▪プレイヤー名またはIDおよびパスワード
                        </p>
                        <p>
                            ▪プロファイル情報（例：プロフィール写真）
                        </p>
                        <p>
                            ▪サービスの利用時に提出されるメッセージやその他のコンテンツ（例：チャットログ、プレイヤーサポートチケット）
                        </p>
                        <p>
                            ▪調査、プロモーション、抽選、コンテスト、その他のイベントへの関連データ
                        </p>
                        <p>
                            ▪Red Falcon Storeを通じて行う購入に関連する支払い情報は、私たちの支払いサービスプロバイダーが収集します
                        </p>
                        <h2>
                            自動的に収集されるデータ。
                        </h2>
                        <p>
                            ▪アカウントとゲームの進行に関するデータ、ほとんどの場合、自動的に作成される内部アカウントID
                        </p>
                        <p>
                            ▪IPアドレスとモバイルデバイス識別子（例：デバイスまたは広告ID）
                        </p>
                        <p>
                            ▪デバイスに関するデータ、例えばデバイス名、オペレーティングシステム、ブラウザタイプと言語、インターネットサービスプロバイダー、モバイルキャリア
                        </p>
                        <p>
                            ▪クッキーと同様の技術を使って収集するデータ（詳細は下記を参照）
                        </p>
                        <p>
                            ▪IPアドレスから導かれるおおよその位置情報
                        </p>
                        <p>
                            ▪サービスの利用に関するデータ、例えばゲームプレイデータ、購入履歴、他のプレイヤーとのインタラクション
                        </p>
                        <p>
                            メールアドレスまたはその他の連絡先情報を使用してRed Falcon IDを作成するオプションもあります。
                        </p>
                        <h2>
                            パートナーから収集するデータ。
                        </h2>
                        <p>
                            また、ソーシャルネットワーキングサイト、データアナリティクスプロバイダー、広告ネットワークなどの第三者パートナーを利用して、私たちについての情報を補足しています。これには、次のようなデータが含まれます：
                        </p>
                        <p>
                            ▪サービス（例：LINE、WeChat、Metaなど）との連携により受け取るデータ
                        </p>
                        <p>
                            ▪人口統計データ（例：IPアドレスの大まかな位置の特定）
                        </p>
                        <p>
                            ▪詐欺対策のデータ（例：ゲーム内での払い戻しの乱用や広告のクリック詐欺）
                        </p>
                        <p>
                            ▪ゲームが実行されているプラットフォームや支払いサービスプロバイダーからのデータ（例：支払い確認データ）
                        </p>
                        <p>
                            ▪広告およびアナリティクス目的のデータ（例：アンケート）、これによりより良いサービスを提供できます
                        </p>
                        <p>
                            ▪プライバシー設定を通じて第三者サービス（例：LINE、WeChat、Metaなど）から利用可能にしたデータ
                        </p>
                        <h2>なぜ私たちはあなたのデータを収集するのか</h2>
                        <p>
                            私たちは様々なビジネス目的であなたのデータを使用します。例えば：
                        </p>
                        <p>
                            サービスを機能させるため。
                        </p>
                        <p>
                            契約を履行するため、以下の必要なデータを処理します：
                        </p>
                        <p>
                            ▪ アカウントを作成し、私たちのゲームをプレイし、サービスを利用することを可能にする
                        </p>
                        <p>
                            ▪ サービスを運営する
                        </p>
                        <p>
                            ▪ 支払いを検証し、確認する
                        </p>
                        <p>
                            ▪ あなたが要求する商品やサービスを提供し、配送する
                        </p>
                        <p>
                            ▪ サービスに関連する通信を送信する
                        </p>
                        <h2>
                            私たちのプレイヤーにとってより適したサービスを提供するため。
                        </h2>
                        <p>
                            私たちのプレイヤーに素晴らしいサービスを提供するため、必要なデータを収集し処理する正当な利益があります：
                        </p>
                        <p>
                            ▪ プレイヤープロファイルを更新し、開発する
                        </p>
                        <p>
                            ▪ サービスとプレイヤー体験を開発し、改善する
                        </p>
                        <p>
                            ▪ あなたとの関係を管理する
                        </p>
                        <p>
                            ▪ サービスの一部としてのソーシャル機能を提供する
                        </p>
                        <p>
                            ▪ サービス体験をカスタマイズする
                        </p>
                        <p>
                            ▪ あなたのコメントや質問に回答し、プレイヤーサポートを提供する
                        </p>
                        <p>
                            ▪ サービス内および他のウェブサイトやサービスでRed Falconのオファーを提供する（メールを含む）
                        </p>
                        <p>
                            ▪ 更新、セキュリティアラート、サポートメッセージなどの関連情報を送信する
                        </p>
                        <p>
                            ▪ 他のプレイヤーとのコミュニケーションを可能にする
                        </p>
                        <h2>
                            パーソナライズされた広告を表示するため。
                        </h2>
                        <p>
                            サービスおよび他の場所（メールを含む）でパーソナライズされた広告を表示するために、必要なデータを処理する正当な利益があります：
                        </p>
                        <p>
                            ▪ サービスに関連するコンテンツにアクセスした内容とあなたのオンライン行動を追跡する
                        </p>
                        <p>
                            ▪ 広告とサービスの提供、ターゲティング、改善を行う
                        </p>
                        <h2>
                            サービスを安全で公平に保つため。
                        </h2>
                        <p>
                            サービスを安全で公平に保つことは、私たちにとって最優先事項です。詳細については、Red Falconの利用規約をご覧ください。
                        </p>
                        <p>
                            サービスおよびそのソーシャル機能を安全で公平に保ち、詐欺を防ぎ、その他の適切な使用を確保するため、私たちは必要なデータを処理する正当な利益があります：
                        </p>
                        <p>
                            ▪ サービスおよびそのソーシャル機能の使用を分析し、監視する
                        </p>
                        <p>
                            ▪ チャットを自動的または手動でモデレートする
                        </p>
                        <p>
                            ▪ 不正行為を行うプレイヤーや問題行動を取るプレイヤーに対処する
                        </p>
                        <h2>
                            分析、プロファイリング、セグメント化するため。
                        </h2>
                        <p>
                            上記のすべてのケースと目的で、私たちは収集したデータを分析、プロファイリング、セグメント化することがあります。
                        </p>
                        <h2>
                            あなたの同意により。
                        </h2>
                        <p>
                            あなたの同意を得て、追加の目的であなたのデータを処理することがあります。
                        </p>
                        <p>
                            私たちは、ゲーム内広告や行動ターゲティング広告の表示およびパーソナライズのために、デバイス識別子を収集し使用することがあります。該当するプライバシー法、特に一般データ保護規則（GDPR）に基づき、これを行うためにあなたの同意を求める必要があります。
                        </p>
                        <p>
                            このデータは、広告パートナーが適切な広告を提供し、広告コンテンツを最適化して同じ広告が何度も表示されないようにするために、あなたの同意を得て共有されます。デバイス識別子は、広告配信とパーソナライズのために選ばれたパートナーと共有されます。
                        </p>
                        <p>
                            ゲーム設定であなたの同意を管理し、デバイス設定で広告追跡を制限することができます。ブラウザやデバイスごとにオプトアウトが固有であることに注意してください。オプトアウトが有効になるまでには少し時間がかかることがあります。
                        </p>
                        <p>
                            アプリ内広告のモバイル広告については、広告識別子をリセットし、デバイスに応じて興味に基づく広告をオプトアウトする（Android）または広告追跡の制限をオンにする（iOS）ことができます。
                        </p>
                        <p>
                            パートナーは、広告ネットワークおよびメディエーションプラットフォームの運営、広告インベントリの入札への参加および支援を行います。パートナーは、詐欺検出目的でデバイス識別子を使用することもあります。詳細については、パートナーのプライバシーポリシーをご確認ください。
                        </p>
                        <p>
                            ironSourceプライバシーポリシー：<a href="https://developers.is.com/ironsource-mobile/air/ironsource-mobile-privacy-policy/#step-1" target="_blank" rel="noopener noreferrer">https://developers.is.com/ironsource-mobile/air/ironsource-mobile-privacy-policy/#step-1</a>
                        </p>
                        <p>
                            Vungleプライバシーポリシー：<a href="https://vungle.com/privacy/" target="_blank" rel="noopener noreferrer">https://vungle.com/privacy/</a>
                        </p>
                        <p>
                            Googleプライバシーポリシー：<a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a>
                        </p>
                        <p>
                            Liftoffプライバシーポリシー：<a href="https://liftoff.io/privacy-policy/" target="_blank" rel="noopener noreferrer">https://liftoff.io/privacy-policy/</a>
                        </p>
                        <p>
                            Mintegralプライバシーポリシー：<a href="https://www.mintegral.com/en/privacy" target="_blank" rel="noopener noreferrer">https://www.mintegral.com/en/privacy</a>
                        </p>
                        <p>
                            Unity Adsプライバシーポリシー：<a href="https://unity.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">https://unity.com/legal/privacy-policy</a>
                        </p>
                        <p>
                            Facebookプライバシーポリシー：<a href="https://www.facebook.com/privacy/policy/" target="_blank" rel="noopener noreferrer">https://www.facebook.com/privacy/policy/</a>
                        </p>
                        <p>
                            Apple Search Adsプライバシーポリシー：<a href="https://searchads.apple.com/privacy" target="_blank" rel="noopener noreferrer">https://searchads.apple.com/privacy</a>
                        </p>
                        <p>
                            Applovinプライバシーポリシー：<a href="https://www.applovin.com/privacy/" target="_blank" rel="noopener noreferrer">https://www.applovin.com/privacy/</a>
                        </p>
                        <p>
                            inMobiプライバシーポリシー：<a href="https://advertising.inmobi.com/privacy-policy" target="_blank" rel="noopener noreferrer">https://advertising.inmobi.com/privacy-policy</a>
                        </p>
                        <p>
                            Pangleプライバシーポリシー：<a href="https://www.pangleglobal.com/zh/privacy" target="_blank" rel="noopener noreferrer">https://www.pangleglobal.com/zh/privacy</a>
                        </p>
                        <p>
                            DT Exchangeプライバシーポリシー：<a href="https://www.digitalturbine.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">https://www.digitalturbine.com/legal/privacy-policy</a>
                        </p>
                        <p>
                            Chartboostプライバシーポリシー：<a href="https://docs.chartboost.com/en/legal/privacy-policy" target="_blank" rel="noopener noreferrer">https://docs.chartboost.com/en/legal/privacy-policy</a>
                        </p>
                        <p>
                            TapSDKプライバシーポリシー: <a href="https://www.tapdb.com/tapsdk-privacy.html" target="_blank" rel="noopener noreferrer">https://www.tapdb.com/tapsdk-privacy.html</a>
                        </p>
                        <p>
                            talkingdataプライバシーポリシー: <a href="https://www.talkingdata.com/privacy.jsp" target="_blank" rel="noopener noreferrer">https://www.talkingdata.com/privacy.jsp</a>
                        </p>



                        <h2>
                            データにアクセスできるのは誰か
                        </h2>
                        <p>
                            Red Falcon以外に、以下の状況で他の者があなたのデータにアクセスすることがあります：
                        </p>
                        <p>
                            他のプレイヤーやユーザー。
                        </p>
                        <p>
                            ソーシャル機能は私たちのゲームの核心的な要素です。例えば、他のプレイヤーやユーザーはあなたのプロファイルデータやゲーム内の活動を見ることができ、投稿されたメッセージを読むことができます。
                        </p>
                        <p>
                            私たちのサービスプロバイダー。
                        </p>
                        <p>
                            Red Falconには、サービスを提供するのを助けるベンダーがいます。これらのベンダーは、Red Falconの指示に従ってのみデータを処理し、ホスティング、プレイヤーサポート、広告、分析、詐欺防止などのタスクを実行します。
                        </p>
                        <p>
                            他の会社および公的機関。
                        </p>
                        <p>
                            支払いの確認（Paypalなどの支払いプロバイダーを使用して）および詐欺や違法行為と戦うために、私たちは他の会社や組織とデータを処理・開示し、合法的な要請に応じて公的機関に提供することがあります。
                        </p>
                        <p>
                            また、法律の遵守、私たちや私たちのプレイヤー、他者の権利、財産、安全を保護するために、あなたの同意に基づいてあなたのデータを開示することもあります。
                        </p>
                        <p>
                            広告およびソーシャルメディアパートナー。
                        </p>
                        <p>
                            サービスには、ソーシャルメディアのインタラクションツール、アプリケーションプログラミングインタフェース（API）やソフトウェア開発キット（SDK）を通じた機能など、パートナーからの機能が含まれています。上記の「あなたの同意により」セクションに示されたこれらのパートナーはあなたのデータにアクセスし、自らのプライバシーポリシーに基づいて運営されます。私たちは、彼らのデータ処理の慣行をよりよく理解するために、彼らのプライバシーポリシーを確認することをお勧めします。
                        </p>
                        <p>
                            これらのパートナーは、あなたの活動やデバイスに関するデータ（たとえば、IPアドレス、モバイル識別子、訪問したページ、場所、時間帯など）にアクセスすることがあります。また、私たちは、あなたについて収集したデータを第三者の広告パートナーと組み合わせて共有することがあります。これらの広告パートナーは、このデータを使用して（他のサービスから収集された同様のデータとともに）、あなたがそのネットワーク内の第三者サービスを訪れたときにターゲット広告を配信する目的で使用することがあります。これらのパートナーは、自らのプライバシーポリシーに基づいて運営されます。この慣行は一般に「興味に基づく広告」または「オンライン行動広告」と呼ばれます。
                        </p>
                        <h2>
                            国際的なデータ転送
                        </h2>
                        <p>
                            私たちのサービスはグローバルな性質を持っているため、あなたのデータは世界中のどこにでも転送されることがあります。異なる国々はあなたの国と異なるデータ保護法を持っているため、私たちはこのプライバシーポリシーで説明されているように、適切な保護措置を講じてあなたのデータを保護することを確実にします。私たちが使用する適たちは、そのような通信からの指示に従って、またはゲーム設定を変更することによって、プロモーションコミュニケーションの受信を拒否することができます。更新された設定がすぐに効果を発揮するとは限りません。なお、サービスに関する非プロモーションのコミュニケーション、たとえばRed Falconの利用規約の更新、このプライバシーポリシーの更新、または取引情報（例：サービス上の購入に関連する情報）などを引き続き受け取ることがあります。
                        </p>
                        <p>
                        たちは、そのような通信からの指示に従って、またはゲーム設定を変更することによって、プロモーションコミュニケーションの受信を拒否することができます。更新された設定がすぐに効果を発揮するとは限りません。なお、サービスに関する非プロモーションのコミュニケーション、たとえばRed Falconの利用規約の更新、このプライバシーポリシーの更新、または取引情報（例：サービス上の購入に関連する情報）などを引き続き受け取ることがあります。
                    </p>
                    <h2>
                        プッシュ通知
                    </h2>
                    <p>
                        私たちはモバイルアプリケーションを通じてプッシュ通知を送信することがあります。あなたはいつでも、モバイルデバイスの設定を変更することによって、これらの通信の受信を拒否することができます。
                    </p>
                    <h2>
                        ターゲット広告からのオプトアウト。
                    </h2>
                    <p>
                        モバイルアプリケーションにおける興味に基づく広告からオプトアウトすることができます。あなたのAndroidまたはiOSデバイスのプライバシー設定を確認し、「アプリに追跡を要求することを許可する」をオフにするか、「広告追跡を制限する」（Apple iOS）または「興味に基づく広告からのオプトアウト」（Android）を選択します。また、ゲーム設定（該当する場合）で提供されるオプションを使用して、パーソナライズされたゲーム内オファーからオプトアウトすることもできます。
                    </p>
                    <p>
                        私たちが保持するあなたの個人データにアクセスする。
                    </p>
                    <p>
                        要求に応じて、私たちはあなたの個人データのコピーを電子形式で提供します。
                    </p>
                    <h2>
                        その他の権利。
                    </h2>
                    <p>
                        あなたは、あなたのデータを訂正する権利、あなたのデータを削除する権利、私たちがあなたのデータを使用または共有する方法に異議を唱える権利、私たちがあなたのデータを使用または共有する方法を制限する権利を持っています。あなたはいつでもあなたの同意を撤回することができます。
                    </p>
                    <p>
                        私たちはすべてのリクエストに対して合理的な時間内に応答します。私たちが満足のいく方法で解決していないプライバシーまたはデータ使用に関する未解決の懸念がある場合、ヨーロッパ経済領域、スイス、または英国のデータ保護当局に未解決の苦情を報告することもできます。
                    </p>
                    <p>
                        上記で説明したデータ主体の権利を行使したい場合は、「CONTACT US」に記載されているサポートオプションを使用してください。私たちは適用法に従ってすべてのリクエストに応答します。あなたのプライバシーを保護するために、リクエストを履行する前にあなたの身元を確認する追加の手順を踏む場合があります。たとえば、購入レシートまたはその他のアカウント情報の提供を求めたり、ゲームIDを通じてあなたのメールアドレスをあなたのゲームアカウントにリンクするように求めたり、または私たちのサービスでのあなたの活動に関する質問に答えるよう求めることがあります。あなたの身元が確認された後、適用法に基づいて必要な場合、あなたはあなたの代理人にあなたの権利を行使させるために、カスタマーサポートスタッフに代理人の連絡先情報を提供することによって、あなたを代表してあなたの権利を行使するように指定することができます。
                    </p>
                    <p>
                        これらの権利を行使する結果として差別的な扱いを受けることはありません。
                    </p>
                    <h1>
                        どのようにしてあなたのデータを保護するか
                    </h1>
                    <h2>
                        セキュリティ対策。
                    </h2>
                    <p>
                        安全で安心できるプレイヤー体験を提供するために、私たちは継続的に管理上の、技術的な、物理的なセキュリティ対策を開発し、実施しています。これにより、あなたのデータが不正アクセスや損失、悪用、変更から保護されます。
                    </p>
                    <h2>
                        データ保持。
                    </h2>
                    <p>
                        あなたのアカウントがアクティブである限り、またはサービスを提供するために必要な限り、私たちはあなたのデータを保持します。たとえば、定期的に使用されていないゲームアカウントを匿名化したり、不必要なデータを定期的に見直して匿名化することがあります。
                        あなたが私たちにあなたの個人データの削除を求めた場合でも、私たちは法的義務に従うため、または紛争を解決し、契約を履行するなど、正当なビジネス利益のために必要な限りあなたのデータを保持します。
                    </p>
                    <h1>
                        子ども
                    </h1>
                    <p>
                        オンラインでの子どものプライバシーの保護は私たちにとって非常に重要です。一般的に、私たちのサービスは13歳未満の子ども（または地域の法律で要求される他の年齢）を対象としておらず、サービスは意図的に子どもから個人データを収集することはありません。ただし、次の段落に記載されているように、例外もあります。
                    </p>
                    <p>
                        子どもに向けていないが、それでも子どもに魅力的かもしれないゲームについては、プレイヤーの年齢に基づいてこれらのサービスへのアクセスを制限する追加の手段を講じます。これらのサービ
                            スでは、プレイヤーが13歳未満（または該当する地域の適用される年齢）であると示した場合、ソーシャルメディアやチャット機能など、特定の機能へのアクセスを制限します。また、私たちのサービスの内部運営を支援するために必要な範囲でのみ個人データの処理を行います。
                        </p>
                        <p>
                            一部のサービスでは、上記の2段落で説明されている年齢よりも高い年齢制限（例えば16歳）を使用しています。これは、私たちのプレイヤーに安全なゲーム体験を提供し、若年層のプレイヤーを保護するためです。
                        </p>
                        <p>
                            保護者または後見人であり、お子様から収集された個人データを確認、修正、または削除したい場合は、上記の「CONTACT US」に記載された方法で私たちに連絡してください。私たちが子どもから個人データを収集していることが明らかになった場合、法的な義務を負う限りではない限り、収集した個人データを削除し、子どものアカウントを解約し、または適用可能な場合は未成年者向けの体験に切り替えます。
                        </p>
                        <h1>
                            カリフォルニア州の住民のための
                        </h1>
                        <p>
                            以下のセクションは、カリフォルニア州の住民にのみ適用されます。
                        </p>
                        <h2>
                            1) データ収集
                        </h2>
                        <p>
                            過去12ヶ月間に収集した個人データのカテゴリとそのデータの出所は、「THE DATA WE COLLECT」セクションで説明されています。
                        </p>
                        <h2>
                            2) データ利用
                        </h2>
                        <p>
                            あなたの個人データを収集するビジネスまたは商業的な目的は、「WHY DO WE COLLECT YOUR DATA」セクションで説明されています。
                        </p>
                        <h2>
                            3) データの開示および/または販売
                        </h2>
                        <p>
                            私たちは第三者とのあなたの個人データの「販売」を行うことはありません。しかし、クッキー情報と広告識別子を私たちの第三者広告プラットフォームと共有し、興味に基づく広告の配信、インストールの属性付け、キャンペーンパフォーマンスの最適化を行うことがあります。この慣行がCCPAの下で「販売」と見なされる場合、あなたは「ターゲット広告からのオプトアウト」セクションで説明されている手順に従って共有を拒否することができます。
                        </p>
                        <p>
                            私たちは16歳未満の未成年者の個人データの「販売」が行われていることを認識していません。CCPAで定義される「販売」という用語に基づきます。
                        </p>
                        <p>
                            過去12ヶ月間に、私たちのサービスの一環として以下のカテゴリの個人データを開示しています：
                        </p>
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <thead>
                                <tr>
                                    <th style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold", textAlign: "center" }}>収集される個人データのカテゴリ</th>
                                    <th style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold", textAlign: "center" }}>Red Falcon が収集するデータの例</th>
                                    <th style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold", textAlign: "center" }}>業務目的で個人データを受け取る可能性のある第三者のカテゴリ</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>識別子</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>本名、別名、一意の個人識別子、オンライン識別子、インターネットプロトコルアドレス、電子メールアドレス、アカウント名、またはその他の類似の識別子。</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>他のプレイヤー(ユーザー名とプロフィールのみ)、サービスプロバイダー、ビジネスパートナー、広告ネットワーク(広告識別子とIPアドレスのみ)</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>カリフォルニア顧客記録法(Cal. Civ. Code § 1798.80(e))に記載されている個人データのカテゴリ</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>名前または電話番号。</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>サービスプロバイダー</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>カリフォルニア州または連邦法の下で保護されている分類特性</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>年齢。</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>サービスプロバイダー、広告ネットワーク(コンプライアンス目的のみ)</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>商業情報</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>購入、取得、または検討された製品またはサービスの記録、またはその他の購入または消費履歴または傾向。</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>サービスプロバイダー、広告ネットワーク</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>インターネットまたはその他の電子ネットワーク活動</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>閲覧履歴、インターネットウェブサイト、アプリケーション、または広告との消費者の相互作用に関する情報。</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>サービスプロバイダー、広告ネットワーク</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>他の個人データから推測される消費者プロファイル</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>消費者の好み、特性、行動を反映したプロファイル。</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>サービスプロバイダー</td>
                                </tr>
                            </tbody>
                        </table>
                        <p>
                            上記で説明されている共有に加えて、合併、売却、またはその他の資産移転が行われた場合、または私たちや他者を保護するために、収集した情報を関連会社と共有することがあります。詳細は「WHO CAN SEE YOUR DATA」セクションをご覧ください。
                        </p>
                        <h2>
                            4) あなたの権利
                        </h2>
                        <p>
                            カリフォルニア州法に基づくあなたの権利は、「Your Rights and Options」セクションで説明されています。
                        </p>
                        <h1>
                            トルコ在住の方へ
                        </h1>
                        <p>
                            有効日：2022年6月1日
                        </p>
                        <p>
                            次のセクションは、トルコ共和国に所在するデータ主体に適用されます。
                        </p>
                        <h2>
                            1) データの収集と処理
                        </h2>
                        <p>
                            あなたの個人データは、特にトルコ個人データ保護法第6698号（“DPL”）に基づいてのみ処理されます。
                        </p>
                        <p>
                            収集した個人データのカテゴリとその出所は、グローバルプライバシーポリシーの「THE DATA WE COLLECT」セクションで説明されています。
                        </p>
                        <p>
                            あなたの個人データを収集する目的は、「WHY DO WE COLLECT YOUR DATA」セクションで説明されています。上記に加え、あなたの個人データは、DPLに基づく以下の法的根拠に基づいて自動的に収集され、処理されます：
                        </p>
                        <p>
                            ▪ 第5条第2項(f)
                        </p>
                        <p>
                            ▪ 第5条第2項(c)
                        </p>
                        <p>
                            ▪ 第5条第1項
                        </p>
                        <h2>
                            2) あなたの権利
                        </h2>
                        <p>
                            DPL第11条に定められているように、私たちが保持する個人データに関して、以下の法的権利があります。トルコ共和国からサービスにアクセスするデータ主体として、データ管理者に申請し、（適用される法律や規制の範囲内で）次の権利を行使することができます：
                        </p>
                        <p>
                            1. あなたの個人データが処理されているかどうかを知る権利
                        </p>
                        <p>
                            2. あなたの個人データが処理されているかどうかに関する情報を要求する権利
                        </p>
                        <p>
                            3. あなたの個人データがどのような目的で処理されているかを知り、それが目的に適合して使用されているかどうかを確認する権利
                        </p>
                        <p>
                            4. あなたの個人データが国内外の第三者に転送されているかどうかを知る権利
                        </p>
                        <p>
                            5. 不完全または不正確なデータがある場合、その訂正を要求する権利
                        </p>
                        <p>
                            6. DPL第7条に定められた条件に基づいて、あなたの個人データの削除または破壊を要求する権利
                        </p>
                        <p>
                            7. あなたの個人データが転送された第三者に、（e）および（f）に基づいて行われた操作の報告を要求する権利
                        </p>
                        <p>
                            8. 自動システムのみを通じて処理されたデータを分析することにより、あなたに不利な結果が生じることに対して異議を申し立てる権利
                        </p>
                        <p>
                            9. あなたの個人データの違法な処理により生じた損害について補償を請求する権利
                        </p>

                        <h2>お問い合わせ</h2>
                        <p>
                            データ保護についての質問がある場合や、個人データに関する問題を解決したい場合には、まず各Red Falconゲーム内のサポート機能を通じてご連絡いただくことをお勧めします。そうすることで、より迅速に対応できます。また、次の方法でも連絡が可能です：
                        </p>

                        <p>
                            担当者名：Red Falcon Games Limited.
                        </p>
                        <p>
                            住所：中国浙江省杭州市余杭区倉前街道時代天元城19棟6階601-2号
                        </p>
                        <p>
                            担当：プライバシー
                        </p>
                        <p>
                            メール：support@falcon-games.com
                        </p>
                            

                    </Text>
                </ContentWithPaddingXl>
            </Container>
            <Footer />
        </AnimationRevealPage>
    );
};
